import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog} from "@angular/material/dialog";
import { ExecucaoHistoricoParameters } from '../historico';

@Component({
    template: `

  `,
    selector: 'app-historico-parametros'
})
export class HistoricoParametrosComponent implements OnInit {

    constructor(public dialog: MatDialog) {
    }

    ngOnInit() {
    }

    openInfoDialog(parameters: ExecucaoHistoricoParameters) {
        this.dialog.open(HistoricoParametrosDialogComponent, {
            data: parameters,
            width: '800px'
        });
    }
}

@Component({
    selector: 'historico-parametros-modal',
    templateUrl: 'historico-parametros-modal.html'
})
export class HistoricoParametrosDialogComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: ExecucaoHistoricoParameters) {
    }
}

